import { Controller } from "@hotwired/stimulus"

// Full-page split editor/preview layout. Replaces the former Alpine component
// in sites/base.html. Initial state is rendered server-side (body class,
// `d-none` visibility, container layout) so first paint is correct with no
// FOUC; this controller drives subsequent toggling and the draggable divider.
export default class extends Controller {
  static targets = ["leftNav", "handle", "preview", "iframe"]
  static values = {
    active: Boolean,
    pct: { type: Number, default: 50 },
    shareUrl: String,
  }

  // Reactive: reflect active state to the body class, pane visibility, and the
  // preview iframe src (lazy-loaded only while open).
  activeValueChanged() {
    const on = this.activeValue
    document.body.classList.toggle("splitview-active", on)
    this.leftNavTargets.forEach((el) => el.classList.toggle("d-none", on))
    this.handleTargets.forEach((el) => el.classList.toggle("d-none", !on))
    this.previewTargets.forEach((el) => el.classList.toggle("d-none", !on))
    this.iframeTargets.forEach((el) => { el.src = on ? this.shareUrlValue : "" })
  }

  // Reactive: divider position drives the layout width via a CSS variable.
  pctValueChanged() {
    document.documentElement.style.setProperty("--sv-pct", this.pctValue + "%")
  }

  toggle(event) {
    if (event) event.preventDefault()
    this.activeValue = !this.activeValue
  }

  close(event) {
    if (event) event.preventDefault()
    this.activeValue = false
  }

  startDrag(event) {
    event.preventDefault()
    this.dragging = true
    document.body.classList.add("sv-dragging")
  }

  onDrag(event) {
    if (!this.dragging) return
    this.pctValue = Math.min(80, Math.max(20, (event.clientX / window.innerWidth) * 100))
  }

  stopDrag() {
    if (!this.dragging) return
    this.dragging = false
    document.body.classList.remove("sv-dragging")
  }

  // Preserve split view across a doc-edit save by flagging the hidden input the
  // server reads to redirect back into split view.
  onFormSubmit(event) {
    if (!this.activeValue) return
    const input = event.target.elements._splitview
    if (input) input.value = "1"
  }
}
